<template>
  <div class="tab-content" >
    <div class="content" v-if="tab.type == 'plain'">
      <div class="common-title">{{ tab.title }}</div>
      <div class="content-text" v-for="(text, textIndex) in tab.content" :key="textIndex">
        <div v-html="text"></div> 
      </div>
      <div class="content-img" v-if="tab.imgList && tab.imgList.length">
        <img v-for="(img, imgIndex) in tab.imgList" :key="imgIndex" :src="img" alt="">
      </div>
    </div>

    <div class="processing processing-con" v-if="tab.type == 'poster'">
      <div class="common-title">
        <span>{{ tab.title }}</span>
      </div>
      <div class="poster-li">
        <img :src="tab.img" />
      </div>
    </div>

    <div class="processing processing-con" v-if="tab.type == 'arrow'">
      <div class="common-title">
        <span>{{ tab.title }}</span>
      </div>
      <div class="processing-li processing-arrow">
          <div class="processing-row" v-for="(item,index) in tab.content" :key="index">
            <div class="processing-icon">
              <img :src="item.img" alt="">
            </div>
            <div class="processing-intr">
                <div class="processing-title">{{ item.subTitle }}</div>
                <div class="processing-tips" v-html="item.subContent"></div>
            </div>
          </div>
      </div>
    </div>

    <div class="processing processing-con" v-if="tab.type == 'license'">
      <div class="common-title">
        <span>{{ tab.title }}</span>
      </div>
      <div class="processing-li">
          <div class="processing-row cover-li" v-for="(item,index) in tab.content" :key="index">
              <img class="left-coverImg" :src="item.imgLeft" alt="">
              <div class="processing-intr cover-intr">
                  <div class="cover-tips" v-html="item.subContent"></div>
                  <img class="right-coverImg" :src="item.imgBottom" alt="">
              </div>
          </div>
      </div>
    </div>
    <div class="processing" v-if="tab.type == 'node'">
      <div class="common-title">
        <span>{{tab.title}}</span>
      </div>
      <div class="services services-pc">
        <el-timeline>
          <el-timeline-item
            v-for="(activity, index) in tab.content"
            :key="index"
            :icon="activity.icon"
            :type="activity.type"
            :color="activity.color"
            :size="activity.size">
            <div>{{activity.subTitle}}</div>
            <div class="activity-content" v-html="activity.subContent"></div>
          </el-timeline-item>
        </el-timeline>
      </div>
      <div class="services-h5">
        <van-steps direction="vertical" :active="tab.content.length + 1">
          <van-step v-for="(item,index) in tab.content" :key="index">
            <div>{{ item.subTitle }}</div>
            <div v-html="item.subContent"></div>
          </van-step>
        </van-steps>
      </div>
    </div>

    <div class="processing" v-if="tab.type == 'success'">
      <div class="common-title">
        <span>{{ tab.title }}</span>
      </div>
      <div class="services services-pc">
        <div class="about-services-li" v-for="(i,iIndex) in tab.content" :key="iIndex">
          <img :src="getImg(iIndex)" alt="">
          <div class="about-services-content">
            <div class="about-services-title">{{ i.subTitle }}</div>
            <!-- <div class="about-services-tips">Excellent project</div> -->
            <div class="about-services-bar"></div>
            <div class="about-services-case" v-html="i.subContent"></div>
          </div>
        </div>
      </div>
      <div class="services-h5" v-if="tab.content">
        <TabSwiper class="swiper-h5" :list="tab.content"/>
      </div>
    </div>

    <div class="processing processing-con" v-if="tab.type == 'qa'">
      <div class="common-title">
        <span>{{ tab.title }}</span>
      </div>
      <div class="question-li">
          <div class="question-row" v-for="(item,index) in tab.content" :key="index">
            <img src="@/assets/xuhao.png" alt="">
            <div class="question-index">{{ getIndex(index)}}</div>
            <div class="question">
              <div class="question-title">{{ item.subTitle }}</div>
              <div class="question-content" v-html="item.subContent"></div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "../components/Swiper.vue"
import TabSwiper from "../components/TabSwiper.vue"
export default {
    props: {
      tab: {
        type: Object,
        default: {}
      }
    },
    components: {Swiper, TabSwiper},
    data() {
      return {
        successImg: require('@/assets/case_1.png'),
        itemIndex: new Date().getTime()
      }
    },
    methods: {
      getIndex(index) {
        let num = Number(index) + 1
        return 9 > index ? '0'+ num : num
      },
      getImg(index) {
        return require(`@/assets/case_${(index % 3) + 1}.png`)
      }
    }
}
</script>

<style lang="scss" scoped>
.tab-content {
  .content {
    width: 1044Px;
    margin: 0 auto;
    .content-text {
      font-size: 18Px;
      font-weight: 400;
      line-height: 40Px;
      color: rgba(102, 102, 102, 1);
      margin-bottom: 24px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .content-img {
      img {
        width: 510Px;
        margin: 12Px 24Px 0 0;
        &:nth-child(2n){
          margin-right: 0;
        }
      }
    }
  }
  .common-title {
    font-size: 32Px;
    font-weight: 400;
    line-height: 46Px;
    color: rgba(51, 51, 51, 1);
    margin: 50Px 0 30Px;
    text-align: center;
  }
  .processing {
    margin-top: 88Px;
  }
  .processing-con {
  }
  .processing-li {
    margin-top: 48Px;
    display: flex;
    justify-content: center;
  }
  .processing-right {
    width: 572Px;
    display: flex;
    flex-wrap: wrap;
    margin-left: 24Px;
  }
  .processing-right .processing-content {
    margin-bottom: 24Px;
    height: 274Px;
  }
  .processing-right .processing-content:nth-child(1) {
    margin-right: 24Px;
  }
  .processing-row {
    display: flex;
  }
  .processing-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 78Px;
    height: 78Px;
    background: url('@/assets/arrow-bg.png') no-repeat;
    img {
      width: 28Px;
    }
  }
  .processing-content {
    position: relative;
  }
  .processing-one {
    width: 574Px;
  }
  .processing-intr {
    bottom: 19Px;
    padding: 0 24Px;
  }
  .processing-title {
    font-size: 24Px;
    color: #333333;
    line-height: 31Px;
  }
  .processing-tips {
    width: 224Px;
    font-size: 12Px;
    color: #777777;
    line-height: 16Px;
    padding-top: 10Px;
  }
  .processing-list {
    font-size: 14Px;
    font-family: MicrosoftYaHei;
    color: #FFFFFF;
    line-height: 19Px;
    margin: 12Px 0 0;
  }
  .cover-li {
    width: 1100Px;
    .left-coverImg {
      width: 50%;
      height: auto;
    }
    .cover-tips {
      font-size: 18Px;
      font-weight: 400;
      line-height: 40Px;
      color: rgba(102, 102, 102, 1);
    }
    .right-coverImg {
      width: 50%;
      height: auto;
    }
  }
  .poster-li {
    width: 1100Px;
    margin: 0 auto;
    text-align: center;
    img {
      object-fit: contain;
    }
  }
  .processing-arrow {
    width: 1100Px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .processing-row {
      width: 365Px;
      margin-bottom: 48Px;
      .processing-title {
        font-size: 16Px;
        font-weight: 400;
        line-height: 24Px;
        color: rgba(51, 51, 51, 1);
      }
      .processing-tips{
        font-size: 14Px;
        font-weight: 400;
        line-height: 20Px;
        color: rgba(119, 119, 119, 1);
      }
    }
  }
  .services {
    margin-top: 39Px;
    display: flex;
    justify-content: center;
  }
  .services-pc {
    width: 1100Px;
    display: flex;
    margin: 0 auto;
  }
  .activity-content {
    font-size: 14Px;
    color: #666;
  }
  .services-h5 {
    display: none;
  }
  .swiper-h5 {
    position: relative;
    padding: 0 80Px;
    width: calc(100% - 160Px);
    height: unset;
    display: none;
  }
  .about-services-li {
    margin: 0 12Px;
    position: relative;
  }
  .about-services-content {
    position: absolute;
    top: 29Px;
    left: 22Px;
    // right: 22Px;
    padding-right: 22Px;
    height: 316Px;
    overflow-y: auto;
  }
  .about-services-title{
    font-size: 16Px;
    font-family: MicrosoftYaHei;
    color: #FFFFFF;
    line-height: 21Px;
  }
  .about-services-tips {
    padding: 5Px 0 8Px;
    font-size: 12Px;
    font-family: MicrosoftYaHei;
    color: #FFFFFF;
    line-height: 16Px;
  }
  .about-services-bar {
    width: 86Px;
    height: 1Px;
    margin-bottom: 10Px;
    background: #fff;
  }
  .about-services-case {
    font-size: 14Px;
    font-family: MicrosoftYaHei;
    color: #FFFFFF;
    line-height: 26Px;
  }
  // .question-li {
  //   width: 1180Px;
  // }
  .question-row {
    position: relative;
    width: 1044Px;
    padding: 12Px 0 0 60Px;
    margin: 0 auto 30Px;
    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 275Px;
    }
    .question-index {
      position: absolute;
      left: 18Px;
      top: 26Px;
      font-size: 22Px;
      font-weight: 500;
      line-height: 26Px;
      color: rgba(110, 89, 26, 1);
    }
    .question {
      position: relative;
      z-index: 2;
      width: 935Px;
      padding: 20Px 18Px;
      border-radius: 12px;
      background: rgba(250, 245, 239, 1);
    }
    .question-title {
      font-size: 16Px;
      font-weight: 700;
      line-height: 24Px;
      color: rgba(51, 51, 51, 1);
      margin-bottom: 2Px;
    }
    .question-content {
      font-size: 14Px;
      font-weight: 400;
      line-height: 22Px;
      color: rgba(102, 102, 102, 1);
    }
  }
  ::v-deep {
    .el-timeline-item__content {
      font-size: 18Px;
      font-weight: 400;
      line-height: 24Px;
    } 
    .el-timeline-item__timestamp {
      font-size: 14Px;
      font-weight: 400;
      line-height: 24Px;
    }
    .el-timeline-item__tail {
      border-left: 2Px solid #aa934d;
    }
    .el-timeline-item__node {
      background:#aa934d;
    }
  }
  @include h5() {
    .header {
    position: relative;
    padding-top: 62px;
    height: 280px;
    img {
      height: 280px;
      position: absolute;
      left: 0;
      // top: 0;
      z-index: -1;
    }
    .header-content {
      margin: 52px 24px 0;
    }
    .title {
      font-size: 32px;
      font-weight: 700;
      line-height: 32px;
      color: rgba(255, 255, 255, 1);
      margin-bottom: 24px;
    }
    .sub-title {
      font-size: 14px;
      font-weight: 400;
      line-height: 16px;
      color: #fff;
      margin-bottom: 36px;
    }
    .sub-tips {
      font-size: 14px;
      font-weight: 400;
      line-height: 14px;
      color: #fff;
      margin-bottom: 30px;
    }
    .tag-list {
      display: flex;
      .tag-li {
        position: relative;
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 0px;
        line-height: 14px;
        color: rgba(255, 255, 255, 1);
        padding: 8px 36px 16px 28px;
        border-radius: 4px;
        background: rgba(176, 152, 80, 1);
        backdrop-filter: blur(4px);
        margin-right: 30px;
      }
      .tag-bg {
        position: absolute;
        top: -6px;
        left: -6px;
        width: 100%;
        height: 100%;
        border-radius: 4px;
        background: rgba(255, 255, 255, 0.3);
        box-shadow:inset 0px -1px 3px  rgba(255, 255, 255, 0.5);
      }
    }
  }
  .tab {
    background: rgba(242, 242, 242, 1);
    overflow-x: auto;
    .tab-list {
      width: 100%;
      display: flex;
      align-items: center;
      height: 60px;
      margin: 0 auto;
      .tab-li {
        display: flex;
        align-items: center;
        height: 60px;
        cursor: pointer;
        &:last-child .li-name{
          border: none;
        }
      }
      .li-name {
        white-space: nowrap;
        font-size: 18px;
        font-weight: 400;
        line-height: 18px;
        color: rgba(153, 153, 153, 1);
        padding: 0 16px;
        border-right: 1px solid rgba(151, 151, 151, 1);
      }
      .actived-tab {
        flex-direction: column;
        justify-content: space-between;
        background: #fff;
        .li-name {
          color: rgba(170, 147, 77, 1);
          border: none;
        }
        img {
          width: 38px;
        }
      }
      .top-bar {
        height: 3px;
      }
      .second-tab{
        .li-name {
          border: none;
        }
      }
    }
  }
  .banner {
    padding-top: 88px;
    img {
      position: relative;
      height: 280px;
      overflow: hidden;
    }
  }
  .banner-h5 {
    display: block;
  }
  .banner-pc {
    display: none;
  }
  .advantages {
    margin-top: 60px;
  }
  .advantages-li {
    margin-top: 58px;
  }
  .common-title {
    font-size: 32px;
    line-height: 42px;
  }
  .common-tips {
    margin-top: 8px;
    line-height: 22px;
  }
  .advantages-li,.processing-li,.processing-row {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .processing-title {
    text-align: center;
  }
  .processing-tips {
    font-size: 24px;
    line-height: 36px;
    width: unset;
  }
  .advantages-pc {
    display: none;
  }
  .advantages-h5 {
    display: block;
    padding: 0 24px;
    margin: 0;
    img {
      width: 703px;
    }
  }
  .advantages-left {
    height: unset;
  }
  .advantages-right {
    width: calc(100% - 48px);
    padding: 30px 24px 60px;
    font-size: 24px;
    line-height: 36px;
    div:first-child {
      font-size: 30px;
      text-indent: 1.6em;
    }
  }
  .processing {
    margin-top: 0;
  }
  .processing{
    padding-top: 0px;
  }
  .processing-icon {
    width: 78px;
    height: 78px;
    padding-bottom: 24px;
    background-size: 78px;
    img {
      width: 28px;
    }
  }
  .processing-title {
    padding-bottom: 24px;
  }
  .processing-tips {
    padding-bottom: 60px;
  }
  .processing-con {
    padding: 0px;
  }
  .processing-li {
    margin-top: 37px;
  }
  .processing-tips {
    padding-top: 0px;
  }
  .processing-title {
    font-size: 28px;
    line-height: 37px;
  }
  .processing-intr {
    padding: 0 24px; 
    text-align: center;
  }
  .services-pc {
    display: none;
  }
  .services-h5 {
    display: block;
  }
  .swiper-h5 {
    display: block;
    width: calc(100% - 224px);
    padding: 0 112px 0 112px;
  }
  .Contact {
    margin-top: 60px;
    padding: 36px 0 60px;
  }
  .Contact-list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 0 20px;
    margin-top: 37px;
    .Contact-li {
      text-align: center;
    }
    .Contact-li:first-child {
      width: 100%;
      text-align: left;
    }
    .Contact-li:nth-child(2) {
      width: 199px;
    }
    .Contact-li:nth-child(3) {
      .Contact-title{
        padding-left: 14px;
      }
      width: 218px;
      .Contact-tips {
        width: 258px;
        margin-left: -18px;
      }
    }
    .Contact-li:last-child {
      .Contact-title{
        padding-left: 20px;
      }
      width: 268px;
      .Contact-tips {
        width: 288px;
      }
    }
    .Contact-tips {
      font-size: 20px;
      transform: scale(0.8);
    }
  }
  .Contact-way {
    display: flex;
    padding: 0;
  }
  .Contact-phone {
    display: flex;
    font-size: 24px;
    line-height: 29px;
    margin: 35px 0 92px 0;
    img {
      width: 30px;
      height: 30px;
      padding-right: 10px ;
    }
    .Contact-num {
      font-size: 24px;
      line-height: 29px;
    }
    span:last-child {
      font-size: 24px;
      line-height: 31px;
    }
  }
  .Contact-phone:first-child {
    padding-right: 20px;
  }
  .Contact-content {
    margin-top: 13px;
    margin-right: 0;
    .Contact-img {
      width: 195px;
      height: 194px;
    }
  }
  .Contact-title {
    text-align: left;
    font-size: 24px;
    line-height: 31px;
  }
  .Contact-tips {
    font-size: 20px;
    line-height: 26px;
    margin-top: 15px;
  }
  .question-row {
    position: relative;
    padding: 12px 0 0 84px;
    margin: 0 auto 30px;
    img {
      position: absolute;
      left: 24px;
      top: 0;
      width: 275px;
    }
    .question-index {
      position: absolute;
      left: 42px;
      top: 26px;
      font-size: 22px;
      font-weight: 500;
      line-height: 26px;
      color: rgba(110, 89, 26, 1);
    }
    .question {
      position: relative;
      z-index: 2;
      width: calc(100vw - 144px);
      padding: 20px 18px;
      border-radius: 12px;
      background: rgba(250, 245, 239, 1);
    }
    .question-title {
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      color: rgba(51, 51, 51, 1);
      margin-bottom: 2px;
    }
    .question-content {
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      color: rgba(102, 102, 102, 1);
    }
  }
  .content {
    width: 100%;
    margin: 0 24px;
    .content-text {
      width: calc(100% - 48px);
      font-size: 18px;
      font-weight: 400;
      line-height: 40px;
      color: rgba(102, 102, 102, 1);
    }
    .content-img {
      img {
        width: calc(50% - 36px);
        margin: 12px 24px 0 0;
        &:nth-child(2n){
          margin-right: 0;
        }
      }
    }
  }
  .cover-li {
    width: 100%;
    overflow: hidden;
    .cover-tips {
      font-size: 18px;
      line-height: 40px;
      text-align: left;
    }
    .cover-intr {
      width: calc(100% - 48px);
      padding: 0 24px;
      .right-coverImg {
        width: 100%;
      }
    }
    .left-coverImg{
      width: calc(100% - 48px);
      padding: 0 24px;
      img {
        object-fit: contain;
      }
    }
  }
  .poster-li {
    width: calc(100% - 48px);
    margin: 0 auto;
    overflow: hidden;
    img {
      max-width: 100%;
      object-fit: contain;
    }
  }
  .processing-arrow {
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .processing-row {
      width: 100%;
      margin-bottom: 20px;
      .processing-title {
        font-size: 18px;
        font-weight: 400;
        line-height: 24px;
        color: rgba(51, 51, 51, 1);
      }
      .processing-tips{
        font-size: 16px;
        font-weight: 400;
        line-height: 20px;
        color: rgba(119, 119, 119, 1);
      }
    }
  }
  ::v-deep {
    .van-step__circle {
      width: 18px;
      height: 18px;
    }
    .van-step--finish .van-step__circle, .van-step--finish .van-step__line {
      background-color: #aa934d;
    }
    .van-step__title {
      font-size: 18px;
      font-weight: 400;
      line-height: 24px;
      div:last-child {
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        color: #999;
      }
    }
  }
}
}
</style>
